import { useState, useEffect, useCallback } from 'react';
import { zonaService } from '../services/supabase';

export function useZonas(usuarioId, campoId) {
  const [zonas, setZonas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadZonas = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await zonaService.getAll(usuarioId, campoId);
      setZonas(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando zonas:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  useEffect(() => {
    loadZonas();
  }, [loadZonas]);

  const createZona = useCallback(async (zona) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await zonaService.create(usuarioId, campoId, zona);
      setZonas(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  const updateZona = useCallback(async (zonaId, updates) => {
    try {
      const updated = await zonaService.update(zonaId, updates);
      setZonas(prev => prev.map(z => z.id === zonaId ? updated : z));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  const deleteZona = useCallback(async (zonaId) => {
    try {
      await zonaService.delete(zonaId);
      setZonas(prev => prev.filter(z => z.id !== zonaId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    zonas,
    setZonas,
    loading,
    error,
    loadZonas,
    createZona,
    updateZona,
    deleteZona,
  };
}
